/* Legal page: highlight the TOC entry for the policy in view (ScrollTrigger, top 45% → bottom 45%). */
(function () {
  function init(root) {
    if (root._lg) return; root._lg = 1;
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-toc] a'));
    var secs = Array.prototype.slice.call(root.querySelectorAll('[data-lsec]'));
    if (!links.length || !secs.length) return;
    var set = function (i) { links.forEach(function (a, k) { a.classList.toggle('is-active', k === i); if (k === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }); };
    var run = function (gsap, ST) {
      secs.forEach(function (el, i) { ST.create({ trigger: el, start: 'top 45%', end: 'bottom 45%', onToggle: function (s) { if (s.isActive) set(i); } }); });
    };
    if (window.Dozzee && Dozzee.gsap) Dozzee.gsap(run);
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-section-type="legal-policies"]').forEach(init); }
  if (window._lgInit) return; window._lgInit = 1;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
